export class UserOffices{
 UserId:number;
 officeID:Array<number>=[];
 AddedBy:string;
 DateAdded:Date;
 IsActive:boolean;
 ChangedBy:string;
 ChangedDate:Date;
 IsRequestor?:boolean;
 isL1?:boolean;
 isL2?:boolean;
}
